<template>
  <div>
    <topHeader></topHeader>
    <div class="gw" :style="{height:920+'px'}" style="position:relative;">
      <div class="img-left">
          <img src="../assets/image_font.png" alt="" :class="{anim:isAnim}">
          <!-- href="https://www.pgyer.com/cccupid" -->
          <!-- href="https://testflight.apple.com/join/jsUOVfKa" -->
          <a target="_blank"  class="toIphone" href="https://apps.apple.com/cn/app/%E6%81%8B%E7%88%B1%E7%89%A9%E8%AF%AD/id1473975969?l=en"></a> 
          <!-- href="http://apps.tiduhn.cn/qbt_upgrade_1.0.2_500_2.apk" -->
          <!-- href="http://apps.tiduhn.cn/qbt_upgrade_1.1.1.apk" -->
          <a target="_blank" href="http://tg-toutiao.tiduhn.cn/official" class="toAndroid"></a>
      </div>
      <img src="../assets/image_like.png" alt="" class="img-right" :class="{anim:isAnim}">
    </div>
  </div>
</template>
<script>
import TopHeader from './header'
	export default {
		name: 'block1',
    props:['isAnim'],
		data (){
			return {
			}
		},
    computed:{
			fullHeight() {
				return this.$store.state.fullHeight;
			}
		},
    components:{
      TopHeader
    },

	}
</script>

<style scoped>
.img-left{
  width: 441.3px;
  height: 440px;
  position: absolute;
  top: 50%;
  margin-top: -250px;
  left: 8%;
}
.img-left>img{
  
  width: 100%;
  display: inline-block;
}

.toIphone,.toAndroid{
  width: 190px;
  height: 55px;
  margin-top: 45px;
  overflow: hidden;
  float: left;
  margin-left: 2%;
  transition: all .8s ease-out;
}
.toIphone{
  background: url('../assets/iphone.png') no-repeat;
  background-size:100%;
  margin-right: 10px;
}
.toAndroid{
  background: url('../assets/android.png') no-repeat;
  background-size:100%;
}


.toIphone:hover,.toIphone:active{
  background: url('../assets/iphone_pressed.png') no-repeat;
  background-size:100%;
}

.toAndroid:hover,.toAndroid:active{
  background: url('../assets/android_pressed.png') no-repeat;
  background-size:100%;
}
.img-right{
  /* height: 500px; */
  width: 580px;
  height: 684px;
  margin: 12% 2% 0 0;
  position: absolute;
  right: 2%;
  top: 50%;
  margin-top: -360px;
}

@media (min-width: 1066px) {
  .img-left>img{
    width: 100%;
  }
  .toIphone,.toAndroid{
    width: 190px;
    height: 70px;
    margin-top: 50px;
  }

  .img-right{
    /* height: 520px; */
    width: 580px;
    height: 684px;
    margin-top: -360px;
  }
}

@media (min-width: 1440px) {

  .img-left>img{
    width: 100%;
  }
  .toIphone,.toAndroid{
    width: 190px;
    height: 70px;
    margin-top: 50px;
  }

  .img-right{
    /* height: 550px; */
    width: 680px;
    height: 784px;
    margin-right: 5%;
    margin-top: -395px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/block1.vue